/* SETGK Pathways — restrained interactions that reinforce the technical route. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pathways-root]').forEach(function (root) {
    var cards = root.querySelectorAll('[data-route-card]');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-active');
        card.setAttribute('aria-pressed', 'true');
      });
    });
  });
});
